import {
  Component,
  Input,
  Output,
  HostBinding,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'ui-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  @HostBinding('style.top')
  @Input()
  offsetY: string;

  @Input()
  show: boolean;

  @Input()
  items: { label: string; value: string }[];

  @Output() selected: EventEmitter<any> = new EventEmitter();

  clicked(value) {
    console.log('clicked', value);
    this.selected.emit(value);
  }
}
